module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "company",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-left"
  }, [_c('z-check', {
    attrs: {
      "label": "Исполнитель по умолчанию",
      "id": "is_default",
      "name": "is_default",
      "value": "1"
    },
    model: {
      value: (_vm.company.is_default),
      callback: function($$v) {
        _vm.$set(_vm.company, "is_default", $$v)
      },
      expression: "company.is_default"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), (_vm.company.id && _vm.company.id != 'new') ? _c('flex-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "min": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'tab-company') ? _c('div', [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "placeholder": "Полное наименование компании",
      "name": "name",
      "id": "name",
      "label": "Название",
      "error": _vm.errors.first('name'),
      "data-vv-name": "name",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.name),
      callback: function($$v) {
        _vm.$set(_vm.company, "name", $$v)
      },
      expression: "company.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "name": "inn",
      "id": "inn",
      "label": "ИНН",
      "error": _vm.errors.first('inn'),
      "type": "number",
      "data-vv-name": "inn",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.inn),
      callback: function($$v) {
        _vm.$set(_vm.company, "inn", $$v)
      },
      expression: "company.inn"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "name": "kpp",
      "id": "kpp",
      "label": "КПП",
      "error": _vm.errors.first('kpp'),
      "type": "number",
      "data-vv-name": "kpp",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.kpp),
      callback: function($$v) {
        _vm.$set(_vm.company, "kpp", $$v)
      },
      expression: "company.kpp"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "type": "number",
      "name": "checking_account",
      "id": "checking_account",
      "label": "Расчётный счёт",
      "error": _vm.errors.first('checking_account'),
      "data-vv-name": "checking_account",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.checking_account),
      callback: function($$v) {
        _vm.$set(_vm.company, "checking_account", $$v)
      },
      expression: "company.checking_account"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "type": "number",
      "data-vv-name": "correspondent_account",
      "data-vv-as": ' ',
      "name": "correspondent_account",
      "id": "correspondent_account",
      "label": "Корреспонденский счёт",
      "error": _vm.errors.first('correspondent_account')
    },
    model: {
      value: (_vm.company.correspondent_account),
      callback: function($$v) {
        _vm.$set(_vm.company, "correspondent_account", $$v)
      },
      expression: "company.correspondent_account"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "name": "bak",
      "id": "bak",
      "label": "БАК",
      "error": _vm.errors.first('bak'),
      "type": "number",
      "data-vv-name": "bak",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.bak),
      callback: function($$v) {
        _vm.$set(_vm.company, "bak", $$v)
      },
      expression: "company.bak"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "name": "bik",
      "id": "bik",
      "label": "Бик",
      "error": _vm.errors.first('bik'),
      "type": "number",
      "data-vv-name": "bik",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.bik),
      callback: function($$v) {
        _vm.$set(_vm.company, "bik", $$v)
      },
      expression: "company.bik"
    }
  })], 1), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "data-vv-name": "bank_name",
      "data-vv-as": ' ',
      "name": "bank_name",
      "id": "bank_name",
      "label": "Наименование банка",
      "error": _vm.errors.first('bank_name')
    },
    model: {
      value: (_vm.company.bank_name),
      callback: function($$v) {
        _vm.$set(_vm.company, "bank_name", $$v)
      },
      expression: "company.bank_name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-4",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "data-vv-name": "initials",
      "data-vv-as": ' ',
      "name": "initials",
      "id": "initials",
      "label": "ФИО руководителя",
      "error": _vm.errors.first('initials')
    },
    model: {
      value: (_vm.company.initials),
      callback: function($$v) {
        _vm.$set(_vm.company, "initials", $$v)
      },
      expression: "company.initials"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-4",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "data-vv-name": "position",
      "data-vv-as": ' ',
      "name": "position",
      "id": "position",
      "label": "Должность руководителя",
      "error": _vm.errors.first('position')
    },
    model: {
      value: (_vm.company.position),
      callback: function($$v) {
        _vm.$set(_vm.company, "position", $$v)
      },
      expression: "company.position"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-4",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "name": "on_base",
      "id": "on_base",
      "label": "На основании",
      "error": _vm.errors.first('on_base'),
      "data-vv-name": "on_base",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.on_base),
      callback: function($$v) {
        _vm.$set(_vm.company, "on_base", $$v)
      },
      expression: "company.on_base"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-4",
    attrs: {
      "label": "Активность",
      "name": "active",
      "id": "active",
      "required": true,
      "data-vv-name": "active",
      "data-vv-as": ' ',
      "error": _vm.errors.first('active')
    },
    model: {
      value: (_vm.company.active),
      callback: function($$v) {
        _vm.$set(_vm.company, "active", $$v)
      },
      expression: "company.active"
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Не выбрано")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" Да ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v(" Нет ")])]), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-4",
    attrs: {
      "label": "По умолчанию",
      "name": "is_default",
      "id": "is_default",
      "required": true,
      "data-vv-name": "is_default",
      "data-vv-as": ' ',
      "error": _vm.errors.first('is_default')
    },
    model: {
      value: (_vm.company.is_default),
      callback: function($$v) {
        _vm.$set(_vm.company, "is_default", $$v)
      },
      expression: "company.is_default"
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Не выбрано")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" Да ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v(" Нет ")])]), _vm._v(" "), _c('z-input', {
    staticClass: "col-4",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "type": "text",
      "name": "doc_prefix",
      "id": "doc_prefix",
      "label": "Префикс для документов",
      "error": _vm.errors.first('doc_prefix'),
      "data-vv-name": "doc_prefix",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.doc_prefix),
      callback: function($$v) {
        _vm.$set(_vm.company, "doc_prefix", $$v)
      },
      expression: "company.doc_prefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Компания работает с НДС",
      "name": "nds",
      "id": "nds",
      "required": true,
      "data-vv-name": "nds",
      "data-vv-as": ' ',
      "error": _vm.errors.first('nds')
    },
    model: {
      value: (_vm.company.nds),
      callback: function($$v) {
        _vm.$set(_vm.company, "nds", $$v)
      },
      expression: "company.nds"
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Не выбрано")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" Да ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v(" Нет ")])]), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "type": "number",
      "name": "nds_value",
      "id": "nds_value",
      "label": "Величина НДС (в %)",
      "error": _vm.errors.first('nds_value'),
      "data-vv-name": "nds_value",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.nds_value),
      callback: function($$v) {
        _vm.$set(_vm.company, "nds_value", $$v)
      },
      expression: "company.nds_value"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "type": "tel",
      "mask": '+7 (999) 999-99-99',
      "name": "phone",
      "id": "phone",
      "label": "Контактный телефон",
      "error": _vm.errors.first('phone'),
      "data-vv-name": "phone",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.phone),
      callback: function($$v) {
        _vm.$set(_vm.company, "phone", $$v)
      },
      expression: "company.phone"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "col-6",
    attrs: {
      "disabled": _vm.progress,
      "readonly": _vm.progress,
      "type": "email",
      "name": "email",
      "id": "email",
      "label": "Контактный email адресс",
      "error": _vm.errors.first('email'),
      "data-vv-name": "email",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.company.email),
      callback: function($$v) {
        _vm.$set(_vm.company, "email", $$v)
      },
      expression: "company.email"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('company-address', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tab-addresses'),
      expression: "activeTab == 'tab-addresses'"
    }],
    attrs: {
      "company-id": _vm.company.id
    },
    model: {
      value: (_vm.company.addresses),
      callback: function($$v) {
        _vm.$set(_vm.company, "addresses", $$v)
      },
      expression: "company.addresses"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0b8bb6e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/companies/views/Company.vue
// module id = 1266
// module chunks = 0